// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as SlabsTable from "../SlabsTable.bs.js";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryConfig from "../../../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as ConfirmationModal from "../ConfirmationModal.bs.js";
import * as CorePricingContext from "../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as MuiLoader$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/MuiLoader.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as CorePricingPreviewVm from "../../../vm-mapper/CorePricingPreviewVm.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as VehicleGeoRegionTitleBar from "../core-pricing/VehicleGeoRegionTitleBar.bs.js";
import * as PricingDashboardRepoManager from "../../../../../app/PricingDashboardRepoManager.bs.js";
import * as PricingDashboardAssetsManager from "../../../../assets/PricingDashboardAssetsManager.bs.js";

var error_sign = PricingDashboardAssetsManager.getImage("error-sign.svg");

var delta_positive = PricingDashboardAssetsManager.getImage("delta-plus.svg");

var delta_negative = PricingDashboardAssetsManager.getImage("delta-negative.svg");

function CorePricingPreviewCmp$CreateConfirmationModal(Props) {
  var isOpen = Props.isOpen;
  var campaign_name = Props.campaign_name;
  var onConfirmCb = Props.onConfirmCb;
  var onCancelCb = Props.onCancelCb;
  return React.createElement(ConfirmationModal.make, {
              title: "Create Campaign",
              isOpen: isOpen,
              onConfirmCb: onConfirmCb,
              onCancelCb: onCancelCb,
              confirm_button_title: "Yes, Submit",
              cancel_button_title: "No, Cancel",
              children: React.createElement("p", undefined, "You are about to create ", React.createElement("b", undefined, campaign_name), " campaign. Are you sure you wish to continue?")
            });
}

var CreateConfirmationModal = {
  make: CorePricingPreviewCmp$CreateConfirmationModal
};

var info_icon = PricingDashboardAssetsManager.getImage("info-icon.svg");

function createCampaign(campaign_req, onSuccessCb, onFailureCb, country) {
  var RepoInstance = PricingDashboardRepoManager.getPricingRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._2(RepoInstance.createCampaign, campaign_req, country);
              }), (function (_data) {
                return Curry._1(onSuccessCb, undefined);
              }), Curry.__1(onFailureCb));
}

function getActions(onBack, onSubmit) {
  return React.createElement(React.Fragment, undefined, React.createElement(PrimaryButton$Catalyst.make, {
                  buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                        TAG: /* Text */0,
                        _0: "Previous"
                      }, undefined, (function (_event) {
                          return Curry._1(onBack, undefined);
                        }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined)
                }), React.createElement(PrimaryButton$Catalyst.make, {
                  buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                        TAG: /* Text */0,
                        _0: "Submit"
                      }, undefined, (function (_event) {
                          return Curry._1(onSubmit, undefined);
                        }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined)
                }));
}

function getErrorString(err) {
  return err._0.message;
}

function CorePricingPreviewCmp$CampaignPreviewFooter(Props) {
  var campaign_name = Props.campaign_name;
  var campaign_req = Props.campaign_req;
  var onCloseSidebar = Props.onCloseSidebar;
  var onBack = Props.onBack;
  var refetch_core_pricings = Props.refetch_core_pricings;
  var country = Props.country;
  var match = React.useState(function () {
        return /* Init */0;
      });
  var set_footer_state = match[1];
  var footer_state = match[0];
  var match$1 = CorePricingContext.useContext(undefined);
  var setActiveTab = match$1.setActiveTab;
  var openSnackbar = match$1.openSnackbar;
  var match$2 = React.useState(function () {
        return false;
      });
  var toggleConfirmationModal = match$2[1];
  return React.createElement("div", {
              className: "create-campaign-footer"
            }, typeof footer_state === "number" ? (
                footer_state !== 0 ? React.createElement(Row$Catalyst.make, {
                        children: null,
                        className: "submitting-action"
                      }, React.createElement(MuiLoader$Catalyst.make, {}), React.createElement("div", undefined, "Creating Campaign")) : getActions(onBack, (function (param) {
                          return Curry._1(toggleConfirmationModal, (function (param) {
                                        return true;
                                      }));
                        }))
              ) : React.createElement(React.Fragment, undefined, React.createElement(Row$Catalyst.make, {
                        children: null,
                        className: "error-message-container"
                      }, React.createElement("img", {
                            src: error_sign
                          }), footer_state._0._0.message), getActions(onBack, (function (param) {
                          return Curry._1(toggleConfirmationModal, (function (param) {
                                        return true;
                                      }));
                        }))), React.createElement(CorePricingPreviewCmp$CreateConfirmationModal, {
                  isOpen: match$2[0],
                  campaign_name: campaign_name,
                  onConfirmCb: (function (param) {
                      createCampaign(campaign_req, (function (param) {
                              Curry._1(openSnackbar, {
                                    TAG: /* Success */0,
                                    _0: campaign_name + " Campaign has been successfully created and sent for approval"
                                  });
                              Curry._1(setActiveTab, (function (param) {
                                      return /* Pending */2;
                                    }));
                              Curry._1(refetch_core_pricings, undefined);
                              return Curry._1(onCloseSidebar, undefined);
                            }), (function (err) {
                              return Curry._1(set_footer_state, (function (param) {
                                            return /* Error */{
                                                    _0: err
                                                  };
                                          }));
                            }), country);
                      Curry._1(toggleConfirmationModal, (function (param) {
                              return false;
                            }));
                      return Curry._1(set_footer_state, (function (param) {
                                    return /* Submitting */1;
                                  }));
                    }),
                  onCancelCb: (function (param) {
                      return Curry._1(toggleConfirmationModal, (function (param) {
                                    return false;
                                  }));
                    })
                }));
}

var CampaignPreviewFooter = {
  createCampaign: createCampaign,
  getActions: getActions,
  getErrorString: getErrorString,
  make: CorePricingPreviewCmp$CampaignPreviewFooter
};

function getFloatDelta(delta) {
  if (delta !== undefined && delta !== 0.0) {
    if (delta < 0.0) {
      return React.createElement("div", {
                  className: "delta-negative"
                }, "(", React.createElement("img", {
                      src: delta_negative
                    }), Math.abs(delta), ")");
    } else {
      return React.createElement("div", {
                  className: "delta-positive"
                }, "(", React.createElement("img", {
                      src: delta_positive
                    }), delta, ")");
    }
  } else {
    return null;
  }
}

function getIntDelta(delta) {
  if (delta !== undefined && delta !== 0) {
    if (delta < 0) {
      return React.createElement("div", {
                  className: "delta-negative"
                }, "(", React.createElement("img", {
                      src: delta_negative
                    }), Math.abs(delta), ")");
    } else {
      return React.createElement("div", {
                  className: "delta-positive"
                }, "(", React.createElement("img", {
                      src: delta_positive
                    }), delta, ")");
    }
  } else {
    return null;
  }
}

function CorePricingPreviewCmp(Props) {
  var active_campaign = Props.active_campaign;
  var new_campaign = Props.new_campaign;
  var onBack = Props.onBack;
  var onCloseSidebar = Props.onCloseSidebar;
  var match = CorePricingContext.useContext(undefined);
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var currency = CountryConfig.getSymbol(country);
  var iso_code = CountryConfig.getIsoCode(country);
  var match$2 = new_campaign.base_details;
  var match$3 = new_campaign.slab_details;
  if (match$2 === undefined) {
    return React.createElement("div", undefined, "Campaign preview not available");
  }
  if (match$3 === undefined) {
    return React.createElement("div", undefined, "Campaign preview not available");
  }
  var campaign = CorePricingPreviewVm.getVm(active_campaign, match$2, match$3, match.role);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "campaign-details-section"
                }, React.createElement(VehicleGeoRegionTitleBar.make, {
                      vehicle_name: campaign.vehicle_name,
                      geo_region: campaign.region
                    }), React.createElement(CardComponent$Catalyst.make, {
                      className: "campaign-primary-info-card",
                      children: null
                    }, React.createElement(Row$Catalyst.make, {
                          children: null,
                          className: ""
                        }, React.createElement("div", undefined, "Status"), React.createElement("div", {
                              className: "pending"
                            }, campaign.status)), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement("div", undefined, "Created By"), React.createElement("div", undefined, campaign.created_by)), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement("div", undefined, "Created On"), React.createElement("div", undefined, Timestamp$Catalyst.toString(campaign.created_on, "DD/MM/yyyy")))), React.createElement(CardComponent$Catalyst.make, {
                      className: "campaign-primary-info-card",
                      children: null
                    }, React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement("div", undefined, "Campaign Name"), React.createElement("div", undefined, campaign.campaign_name)), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement(LabelUnit$Catalyst.make, {
                              label: "Start Date",
                              unit: "dd/mm/yyyy"
                            }), React.createElement("div", undefined, Timestamp$Catalyst.toString(campaign.start_date, "DD/MM/yyyy"))), React.createElement("hr", {
                          className: "separator"
                        }), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement(LabelUnit$Catalyst.make, {
                              label: "Base Fare",
                              unit: currency
                            }), React.createElement(Row$Catalyst.make, {
                              children: null
                            }, Currency.toCurrencyString(campaign.base_fare.value, currency), getFloatDelta(Currency.fromOptCurrency(campaign.base_fare.delta)))), React.createElement("hr", {
                          className: "separator"
                        }), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement(LabelUnit$Catalyst.make, {
                              label: "Free Duration",
                              unit: "min"
                            }), React.createElement(Row$Catalyst.make, {
                              children: null
                            }, String(campaign.free_duration.value) + " mins", getIntDelta(campaign.free_duration.delta))), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement(LabelUnit$Catalyst.make, {
                              label: "Waiting Rate per min",
                              unit: currency + "/min"
                            }), React.createElement(Row$Catalyst.make, {
                              children: null
                            }, Currency.toCurrencyString(campaign.waiting_rate.value, currency), getFloatDelta(Currency.fromOptCurrency(campaign.waiting_rate.delta)))), React.createElement("hr", {
                          className: "separator"
                        }), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement(LabelUnit$Catalyst.make, {
                              label: "Free KMs",
                              unit: "kms"
                            }), React.createElement(Row$Catalyst.make, {
                              children: null
                            }, String(campaign.free_kms.value) + " KMs", getIntDelta(campaign.free_kms.delta))), React.createElement(Row$Catalyst.make, {
                          children: null
                        }, React.createElement(LabelUnit$Catalyst.make, {
                              label: "Price per min for free KMs",
                              unit: currency + "/min"
                            }), React.createElement(Row$Catalyst.make, {
                              children: null
                            }, Currency.toCurrencyString(campaign.free_km_price_per_min.value, currency), getFloatDelta(Currency.fromOptCurrency(campaign.free_km_price_per_min.delta))))), React.createElement(SlabsTable.make, {
                      slabs: campaign.slabs
                    })), React.createElement(CorePricingPreviewCmp$CampaignPreviewFooter, {
                  campaign_name: campaign.campaign_name,
                  campaign_req: CorePricingPreviewVm.getCampaignRequestParams(match$2, match.geo_region.geo_region_id, match.vehicle_type.vehicle_id, match$3, iso_code),
                  onCloseSidebar: onCloseSidebar,
                  onBack: onBack,
                  refetch_core_pricings: match.refetch_core_pricings,
                  country: country
                }));
}

var make = CorePricingPreviewCmp;

export {
  error_sign ,
  delta_positive ,
  delta_negative ,
  CreateConfirmationModal ,
  info_icon ,
  CampaignPreviewFooter ,
  getFloatDelta ,
  getIntDelta ,
  make ,
  
}
/* error_sign Not a pure module */
